export const WRITING_ASSISTANT_VOICE_INPUT_COMMAND = Object.freeze({
  PLAY_PAUSE: 'playPause',
  TOGGLE_DICTATION: 'toggleDictation'
})

export const WRITING_ASSISTANT_VOICE_INPUT_MODE = Object.freeze({
  DICTATE: 'dictate',
  EDIT: 'edit'
})

export const writingAssistantVoiceInputAction = ({
  command,
  textFieldSpeechInputActive,
  instructionSpeechInputActive,
  applying
}) => {
  if (command === WRITING_ASSISTANT_VOICE_INPUT_COMMAND.TOGGLE_DICTATION) {
    return textFieldSpeechInputActive || instructionSpeechInputActive
      ? 'stop'
      : null
  }
  if (command !== WRITING_ASSISTANT_VOICE_INPUT_COMMAND.PLAY_PAUSE) return null
  if (applying) return null
  if (textFieldSpeechInputActive) return 'enterEdit'
  if (instructionSpeechInputActive) return 'commitEdit'
  return null
}

export const writingAssistantVoiceInputState = ({
  textFieldSpeechInputActive,
  instructionSpeechInputActive
}) => {
  if (instructionSpeechInputActive) {
    return {
      active: true,
      mode: WRITING_ASSISTANT_VOICE_INPUT_MODE.EDIT
    }
  }
  if (textFieldSpeechInputActive) {
    return {
      active: true,
      mode: WRITING_ASSISTANT_VOICE_INPUT_MODE.DICTATE
    }
  }
  return { active: false }
}

const isPlainObject = value =>
  value !== null && typeof value === 'object' && !Array.isArray(value)

export const normalizeEditV2ToolCall = response => {
  if (!isPlainObject(response) || !isPlainObject(response.toolCall)) {
    throw new Error('edit-v2 returned no tool call')
  }
  const { name, arguments: args } = response.toolCall
  if (!isPlainObject(args)) {
    throw new Error('edit-v2 returned invalid tool arguments')
  }
  if (name === 'edit') {
    if (Object.keys(args).length !== 1 || typeof args.document !== 'string') {
      throw new Error('edit-v2 returned an invalid edit action')
    }
    return { name, arguments: { document: args.document } }
  }
  if (name === 'undo' || name === 'redo' || name === 'noop') {
    if (Object.keys(args).length !== 0) {
      throw new Error(`edit-v2 returned an invalid ${name} action`)
    }
    return { name, arguments: {} }
  }
  throw new Error('edit-v2 returned an unknown tool action')
}
